

function getUser() {
  const prom = new Promise((resolve, reject) => {
    const req = fetch("/api/me", { credentials: "include" });
    req.then((response) => {
      if (response.ok) {
        resolve(response.json());
      } else if (response.status === 401) {
        throw new Error(response.status);
      } else {
        throw new Error("Request failed");
      }
    }).catch((error) => {
      reject(error);
    });
  });
  return prom;
}

function getNote(date) {
  const prom = new Promise((resolve, reject) => {
    const req = fetch(`/api/note/${date.getFullYear()}/${(date.getMonth() + 1)}/${date.getDate()}/`, { credentials: "include" });
    req.then((response) => {
      if (response.ok) {
        resolve(response.json());
      } else if (response.status === 401) {
        throw new Error(response.status);
      } else {
        throw new Error("Request failed");
      }
    }).catch((error) => {
      reject(error);
    });
  });
  return prom;
}

function saveNote(note) {
  const date = new Date(note.date);
  const prom = new Promise((resolve, reject) => {
    const req = fetch(`/api/note/${date.getFullYear()}/${date.getMonth() + 1}/${date.getDate()}/`,
      { method: "POST",
        body: JSON.stringify(note),
        headers: { "Content-Type": "application/json" },
        credentials: "include" });
    req.then((response) => {
      if (response.ok) {
        resolve(response.json());
      } else if (response.status === 401) {
        throw new Error(response.status);
      } else {
        throw new Error("Request failed");
      }
    }).catch((error) => {
      reject(error);
    });
  });
  return prom;
}

export default {
  getUser,
  getNote,
  saveNote,
};



// WEBPACK FOOTER //
// ./src/api.js